/**
 * @voltxampere/engine — Assertion DSL abstract syntax tree (Sprint 9)
 *
 * The AST is the neutral contract between parser and evaluator.
 * Every parser production maps onto one of the variants here;
 * every evaluator branch consumes one.
 *
 * Shape is pinned to Blueprint §24.3 — any change here needs an
 * ADR because it ripples into:
 *
 *   - the parser (`./parser.ts`),
 *   - the evaluator (`./evaluate.ts`),
 *   - SPECS §6 formal EBNF,
 *   - any future plug-in measurement function added to
 *     `./measurements.ts`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const ANALYSIS_KINDS = ["DC", "TRANSIENT", "AC"];
//# sourceMappingURL=ast.js.map